// extracted by mini-css-extract-plugin
export default {"modal":"Efa-z","modalContent":"Ffa-z","footer":"Gfa-z","cancelBtn":"Hfa-z","disabled":"Ifa-z","formWrapper":"Jfa-z","fade":"Kfa-z","fade-in":"Lfa-z","iframe":"Mfa-z"};